import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-previous-orders',
  templateUrl: './previous-orders.component.html',
  styleUrls: ['./previous-orders.component.css']
})
export class PreviousOrdersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
